import { Pageable } from '@cyberlabrs/types';
import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { LeaveRequestApi } from '../../../api';
import { dispatch } from '../../../store';
import { addProfileLeaveRequestHistory } from '../../../store/slices/user-profile.slice';

interface ILeaveRequestSearchParams extends Pageable {}

const SIZE = 20;
const DEFAULT_PAGE = 0;

const useHttpGetLeaveRequestHistoryByUserSubOnMountAndExec = (userSub: string, params?: ILeaveRequestSearchParams) => {
    const leaveRequestApi = useContainer(LeaveRequestApi);
    const [isReady, setIsReady] = useState(false);
    const [total, setTotal] = useState(0);

    const { exec, abort } = leaveRequestApi.getLeaveRequestsHistoryForUserProfile({
        query: {
            size: params?.size ?? SIZE,
            page: params?.page ?? DEFAULT_PAGE,
            sort: 'fromDate',
            direction: 'desc',
        },
        params: { userSub },
        onSuccess: res => {
            dispatch(addProfileLeaveRequestHistory(res.body.items));
            setTotal(parseInt(res.body.total));
        },
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { exec, isReady, total };
};

export default useHttpGetLeaveRequestHistoryByUserSubOnMountAndExec;
